import reportFilename from "../reportFilename";
import buildAcrHtmlString from "./buildAcrHtmlString";

export default function downloadAcrHtml(evaluation, catalog) {
  const htmlString = buildAcrHtmlString(evaluation, catalog);
  const blob = new Blob([htmlString], { type: "text/html;charset=utf-8" });
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = `${reportFilename(evaluation)}.html`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);
}
